// reducers
export default function search(state = {}, action) {
  switch (action.type) {
    case 'FETCH_SEARCH_DATA':
      return { ...state, suggestions: action.search, responseSource: action.responseSource };
    case 'FETCH_TOP_SEARCHES_SUCCESSFULL':
      return { ...state, topSearches: action.topSearches };
    case 'CLEAR_SEARCH_DATA':
      return { ...state, suggestions: [] };
    case 'FETCH_SEARCH_STATUS':
      return { ...state, invalidSearchInput: action.status };
    default:
      return state;
  }
}
